var React = require('react');

function AccountInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.5 12C16.903 12 21.5167 16.7417 21.9644 23H1.03558C1.48333 16.7417 6.09703 12 11.5 12Z","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"11.613","cy":"6.19355","r":"5.19355","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

AccountInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = AccountInline;

AccountInline.default = AccountInline;
